import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { isHttpError } from "./api-client";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getErrorMessage = (error: unknown) => {
  if (isHttpError(error)) return error.message;
  if (error instanceof Error) return error.message;
  return "Unknown error";
};
